// Translations for the Oradea Art Nouveau AR Viewer
// Supported languages: Romanian (ro), English (en), Hungarian (hu), German (de)

export const translations = {
  ro: {
    appTitle: 'Manifest of Oradea Art Nouveau',
    selectLanguage: 'Selectați limba',
    languageName: 'Română',
    credits: 'Credite',
    mainTitle: 'Interioare din Oradea',
    subtitle: 'Străzile Oradei s-au reinventat la începutul secolului XX, înflorind în stil <strong>Secession</strong>.',
    loading: 'Se încarcă modelul 3D...',
    arReady: 'Model 3D Gata!',
    arStart: 'Pornește Experiența AR',
    arExit: 'Ieși din AR',
    arPointSurface: 'Îndreaptă către o suprafață pentru a plasa modelul',
    arModelPlaced: 'Model plasat! Apasă pentru a ieși din AR',
    arNotAvailable: 'AR indisponibil',
    arViewIOS: 'Vizualizează în AR (iOS)',
    readStory: 'citește povestea',
    previousAsset: 'Obiectul anterior',
    nextAsset: 'Obiectul următor',
    bibliografie: 'Bibliografie',
    povesteaSecession: 'Povestea Secession',
    tutorial: 'Tutorial',
    infoProiect: 'Info Proiect',
    watchTutorial: 'Urmărește tutorial',
    buildingCasaErtler: 'Casa Ertler',
    buildingPalatulVulturulNegru: 'Palatul Vulturul Negru',
    buildingPalatulUllmann: 'Palatul Ullmann',
    buildingCasaDarvasLaRoche: 'Casa Darvas-La Roche',
    buildingPalatulCamereiDeComert: 'Palatul Camerei de Comerț',
    buildingVilaOkanyiSchwartz: 'Vila Okányi-Schwartz',
  },

  en: {
    appTitle: 'Manifest of Oradea Art Nouveau',
    selectLanguage: 'Select Language',
    languageName: 'English',
    credits: 'Credits',
    mainTitle: 'Interiors of Oradea',
    subtitle: 'Oradea\'s streets reinvented at the beginning of the 20th century, blooming in <strong>Secession</strong> style.',
    loading: 'Loading 3D Model...',
    arReady: '3D Model Ready!',
    arStart: 'Start AR Experience',
    arExit: 'Exit AR',
    arPointSurface: 'Point at a surface to place the model',
    arModelPlaced: 'Model placed! Tap to exit AR',
    arNotAvailable: 'AR not available',
    arViewIOS: 'View in AR (iOS)',
    readStory: 'read story',
    previousAsset: 'Previous asset',
    nextAsset: 'Next asset',
    bibliografie: 'Bibliography',
    povesteaSecession: 'The Secession Story',
    tutorial: 'Tutorial',
    infoProiect: 'About',
    watchTutorial: 'Watch tutorial',
    buildingCasaErtler: 'Ertler House',
    buildingPalatulVulturulNegru: 'Black Eagle Palace',
    buildingPalatulUllmann: 'Ullmann Palace',
    buildingCasaDarvasLaRoche: 'Darvas-La Roche House',
    buildingPalatulCamereiDeComert: 'Chamber of Commerce Palace',
    buildingVilaOkanyiSchwartz: 'Okányi-Schwartz Villa',
  },

  hu: {
    appTitle: 'Manifest of Oradea Art Nouveau',
    selectLanguage: 'Válasszon nyelvet',
    languageName: 'Magyar',
    credits: 'Készítők',
    mainTitle: 'Nagyváradi belső terek',
    subtitle: 'Nagyvárad utcái a XX. század elején újították meg magukat, <strong>szecessziós</strong> stílusban virágozva.',
    loading: '3D modell betöltése...',
    arReady: '3D modell kész!',
    arStart: 'AR élmény indítása',
    arExit: 'Kilépés AR-ból',
    arPointSurface: 'Mutasson egy felületre a modell elhelyezéséhez',
    arModelPlaced: 'Modell elhelyezve! Érintse meg a kilépéshez',
    arNotAvailable: 'AR nem elérhető',
    arViewIOS: 'Megtekintés AR-ban (iOS)',
    readStory: 'olvass tovább',
    previousAsset: 'Előző tárgy',
    nextAsset: 'Következő tárgy',
    bibliografie: 'Bibliográfia',
    povesteaSecession: 'A szecesszió története',
    tutorial: 'Tutorial',
    infoProiect: 'Projektinfó',
    watchTutorial: 'Nézd meg a tutorialt',
  },

  de: {
    appTitle: 'Manifest of Oradea Art Nouveau',
    selectLanguage: 'Sprache wählen',
    languageName: 'Deutsch',
    credits: 'Impressum',
    mainTitle: 'Innenräume von Oradea',
    subtitle: 'Die Straßen von Oradea haben sich zu Beginn des 20. Jahrhunderts neu erfunden und im <strong>Sezessionsstil</strong> erblüht.',
    loading: '3D-Modell wird geladen...',
    arReady: '3D-Modell bereit!',
    arStart: 'AR-Erlebnis starten',
    arExit: 'AR beenden',
    arPointSurface: 'Zeigen Sie auf eine Oberfläche, um das Modell zu platzieren',
    arModelPlaced: 'Modell platziert! Tippen Sie zum Beenden',
    arNotAvailable: 'AR nicht verfügbar',
    arViewIOS: 'In AR ansehen (iOS)',
    readStory: 'Geschichte lesen',
    previousAsset: 'Vorheriges Objekt',
    nextAsset: 'Nächstes Objekt',
    bibliografie: 'Bibliographie',
    povesteaSecession: 'Die Sezession-Geschichte',
    tutorial: 'Tutorial',
    infoProiect: 'Über das Projekt',
    watchTutorial: 'Tutorial ansehen',
  }
};

// Language configuration — only RO and EN enabled for now
export const languages = [
  { code: 'ro', name: 'Română', flag: '/flags/ro.webp' },
  { code: 'en', name: 'English', flag: '/flags/en.webp' },
  // { code: 'hu', name: 'Magyar', flag: '/flags/hu.webp' },
  // { code: 'de', name: 'Deutsch', flag: '/flags/de.webp' }
];

/**
 * Detect default language from browser settings.
 * Romanian browser → 'ro', everything else → 'en'.
 */
function detectDefaultLanguage() {
  const browserLang = navigator.language || navigator.userLanguage || '';
  return browserLang.startsWith('ro') ? 'ro' : 'en';
}

export function getCurrentLanguage() {
  return localStorage.getItem('oradea-language') || detectDefaultLanguage();
}

export function setCurrentLanguage(langCode) {
  localStorage.setItem('oradea-language', langCode);
}

export function t(key) {
  const lang = getCurrentLanguage();
  return translations[lang]?.[key] || translations['ro'][key] || key;
}

export function getSelectLanguageTexts() {
  return [
    translations.ro.selectLanguage,
    translations.en.selectLanguage,
    translations.hu.selectLanguage,
    translations.de.selectLanguage
  ];
}
